import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {Section} from 'common/components/items-menu/types';
import {GetSortedMenuSections} from 'common/widgets/query-block/properties-menu/types';

import template from './index.jade';

interface FilterBarUserPropertiesFilterState {
  getSortedMenuSections: (sections: Section[]) => Section[];
}

export class FilterBarUserPropertiesFilter extends Component<FilterBarUserPropertiesFilterState> {
  static get attrsSchema() {
    return {
      ...super.attrsSchema,
      name: `string`,
      'project-id': `number`,
      'single-data-group': `string`,
      selected: `json`,
      label: `string`,
      'workspace-id': `string`,
      'selector-icon': `string`,
      'track-name': `string`,
    };
  }

  get config() {
    return {
      template,
      defaultState: {
        getSortedMenuSections: null,
      },
      helpers: {
        handleQueryBlockSelect: ({detail}) => {
          const {item, rawItem, commit} = detail;

          if (commit) {
            this.dispatchEvent(
              new CustomEvent(`applyFilter`, {
                detail: {
                  name: this.attr(`name`),
                  selected: item,
                },
              }),
            );
          } else {
            const selectedItem = {
              value: rawItem.value,
              resourceType: rawItem.resourceType,
              isSelected: rawItem.isSelected,
            };
            this.dispatchEvent(
              new CustomEvent(`changeFilter`, {
                detail: {
                  name: this.attr(`name`),
                  item: selectedItem,
                  value: selectedItem.value,
                },
              }),
            );
          }
        },
        handleQueryBlockOpen: () => {
          this.dispatchEvent(
            new CustomEvent(`menuChange`, {
              detail: {
                name: this.attr(`name`),
                isOpen: true,
              },
            }),
          );
        },
        handleQueryBlockClose: () => {
          this.dispatchEvent(
            new CustomEvent(`menuChange`, {
              detail: {
                name: this.attr(`name`),
                isOpen: false,
              },
            }),
          );
        },
        handleQueryBlockSelectAll: ({detail}) => {
          this.dispatchEvent(new CustomEvent(`selectAll`, {detail}));
        },
      },
    };
  }

  set getSortedMenuSections(getSortedMenuSections: GetSortedMenuSections) {
    this.update({getSortedMenuSections});
  }
}

export const FilterBarUserPropertiesFilterEl = defineAndMakeJsxFactory(
  `filter-bar-user-properties-filter`,
  FilterBarUserPropertiesFilter,
);
